import { render, staticRenderFns } from "./AccettazioneNominaITA.vue?vue&type=template&id=88259de2&"
import script from "./AccettazioneNominaITA.vue?vue&type=script&lang=js&"
export * from "./AccettazioneNominaITA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports